module.exports = __webpack_public_path__ + "img/move_up.00258cb3.png";